import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BenefitWithoutCard,
  BfluenceIntegrityControllerService
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-benefit-without-card',
  templateUrl: './benefit-without-card.component.html',
  styleUrl: './benefit-without-card.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class BenefitWithoutCardComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn('GlamId', 'glamId', true, 'text'),
    new TableColumn('CreditCardId', 'creditCardId', true, 'number')
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<BenefitWithoutCard>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar estes benefícios?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixBenefitWithoutCard(elements)
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
